(function() {
	
	var Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Button = include("springroll.pixi.Button"),
		Sound = include("springroll.Sound");
	
	var GoalTile = function(state, isGoal)
	{
		this.state = state;
		
		var buttonTextures =
		{
			priority: ["highlighted", "disabled", "down", "over", "up"],
			up: isGoal ? "finalTile_up" : "tile_up",
			over: isGoal ? "finalTile_over" : "tile_over",
			down: isGoal ? "finalTile_down" : "tile_down",
			highlighted: isGoal ? "finalTile_highlight" : "tile_highlight"
		};
		
		Button.call(this, buttonTextures);
		
		this.enabled = false;
		
		this.pivot.x = this.pivot.y = this.back.width / 2;
		
		this.highlight = this.highlight.bind(this);
		this.unhighlight = this.unhighlight.bind(this);
		this.triggerWalk = this.triggerWalk.bind(this);
		this.onOver = this.onOver.bind(this);
		this.on("buttonPress", this.triggerWalk);
		this.on("mouseover", this.onOver);
	};
	
	// Extend MovieClip
	var s = Button.prototype;
	var p = GoalTile.prototype = Object.create(s);
	
	p.highlight = function()
	{
		this.highlighted = true;
	};
	
	p.unhighlight = function()
	{
		this.highlighted = false;
	};
	
	p.onOver = function()
	{
		Sound.instance.play("SFX_TileHover");
	};
	
	p.triggerWalk = function()
	{
		Sound.instance.play("SFX_TileClick");
		this.state.startElmoWalk();
	};
	
	p.destroy = function()
	{
		this.state = this.highlight = this.unhighlight = this.triggerWalk = this.onOver = null;
		s.destroy.call(this);
	};
	
	namespace('heist').GoalTile = GoalTile;
}());